import React from "react";
import { situations } from "../mock";
import { ArrowUpRight } from "lucide-react";

export default function Situations() {
  return (
    <section className="bg-[#F4F0E9] py-20 lg:py-24">
      <div className="mx-auto max-w-[1320px] px-5 lg:px-8">
        <h2 className="font-serifDisplay text-[34px] leading-tight text-[#26241F] lg:text-[44px]">
          Où en êtes-vous avec votre bien ?
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-3">
          {situations.map((s, i) => (
            <a
              key={i}
              href="#contact"
              className="group flex flex-col justify-between rounded-2xl border border-[#e4ddce] bg-[#FBF9F5] p-7 transition-all duration-300 hover:-translate-y-1 hover:border-[#B08D57] hover:shadow-[0_18px_40px_-20px_rgba(38,36,31,0.35)]"
            >
              <div>
                <h3 className="text-[19px] font-semibold text-[#26241F]">{s.title}</h3>
                <p className="mt-3 text-[15px] leading-relaxed text-[#6e6a62]">{s.text}</p>
              </div>
              <span className="mt-6 flex h-11 w-11 items-center justify-center rounded-full bg-[#26241F] text-white transition-all group-hover:bg-[#B08D57]">
                <ArrowUpRight className="h-5 w-5" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
